import { useParams } from "react-router-dom";

const useFilters = (componentData) => {
    const params = useParams();

    return Object.keys(params).length > 0
        ? Object.values(params).flatMap((val) => {
              return Object.values(componentData).filter((data) => {
                  return data.link.linkText.toLowerCase().includes(val);
              });
          })
        : componentData;
};

export default useFilters;
